module.exports = __webpack_public_path__ + "static/media/How to create letter templates with use of dynamic keys.fe69c5fe.png";